import React, { useRef } from 'react';
import axios from 'axios';
import { Icon, TooltipHost } from '@fluentui/react';
import Api from '../../../services/Api';

const DeleteRedirect = ({redirectId, siteId, setLoading, refresh}) => {
    const cancelToken = axios.CancelToken;

    const cancelSource = useRef(null);

    const deleteRedirect = () => {
        setLoading(true);

        if (cancelSource.current) {
            cancelSource.current.cancel();
        }
        
        cancelSource.current = cancelToken.source();

        const post = {
            siteRedirectId: redirectId,
            id: siteId
        }

        let url = `/AdminUpdateSiteRequest`;

        Api.post(url, post, {
            cancelToken: cancelSource.current.token})
        .then(res => res.data)
        .then(c => {
            setLoading(false);
            refresh(siteId);
        })
        .catch(error => {
            console.log(error);
        });

        return () => {
            cancelSource.current.cancel();
        }
    }

    return (
        <div>
            <TooltipHost content="Delete redirect">
                <Icon style={iconStyles} iconName="Cancel" onClick={deleteRedirect}/>
            </TooltipHost>
        </div>
    );
}

const iconStyles = {
    cursor: 'pointer',
    margin: '0 5px',
    fontSize: '16px',
    fontWeight: '600'
}

export default DeleteRedirect;


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/DeleteRedirect.js